import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBase from '@material-ui/core/InputBase';
var BootstrapInput = withStyles(function (theme) { return ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 12,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}); })(InputBase);
export var SelectMaterial = function (props) {
    var options = props.options, onSelect = props.onSelect, value = props.value;
    var _a = useState(), dropdownOptions = _a[0], setDropdownOptions = _a[1];
    useEffect(function () {
        setDropdownOptions(options);
    }, [options]);
    return (React.createElement("div", null,
        React.createElement(Select, { labelId: "demo-customized-select-label", id: "demo-customized-select", value: value, onChange: onSelect, fullWidth: true, input: React.createElement(BootstrapInput, null) }, dropdownOptions && dropdownOptions.length ? dropdownOptions.map(function (option, index) {
            return React.createElement(MenuItem, { key: index, value: option.value }, option.label);
        }) : null)));
};
export default SelectMaterial;
